<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>关于我们</h3>
                </el-col>
            </el-row>
            <el-form :model="aboutForm" ref="aboutForm" :rules="bannerFormFules">
                <el-form-item label="关于我们LOGO图" label-width="150px">
                    <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" :data="uptoken">
                        <img v-if="imgUrl" :src="imgUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="当前版本号" label-width="150px" prop="description">
                    <el-input v-if="aboutForm.value" v-model="aboutForm.value.version"></el-input>
                </el-form-item>
                <el-form-item label-width="150px">
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    
    </div>
</template>

<script>
    import {
        getGlobalSettings,
        getVersions,
        patchVersions,
        patchGlobalSettings,
        patchVersionsId
    } from '../../api/version'
    
    export default {
        data() {
            return {
                aboutForm: {},
                dialogImageUrl: '',
                videoUrl: '',
                imgUrl: '',
                bannerFormFules: {
                    name: [{
                        required: true,
                        message: '请输入享玩甄选描述',
                        trigger: 'blur'
                    }],
                    shop: [{
                        type: 'number',
                        required: true,
                        message: '请选择商品',
                        trigger: 'blur'
                    }]
                },
    
                uptoken: {
                    token: sessionStorage.token
                },
                productArr: [],
                imageUrl: '',
                fileListDetail: [],
                type: 'video',
                title: '',
                picArr: [],
                videoData: '',
                global: {},
                curVersion: ''
            }
        },
        created() {
            getGlobalSettings().then(res => {
                this.global = res.data
                res.data.forEach(item => {
                    if (item.SettingKey === 'wx_about') {
                        this.curVersion = item.SettingValue
    
                        getVersions().then(res => {
                            console.log(res.data)
                            res.data.forEach(item2 => {
                                if (item2.version === this.curVersion) {
                                    this.aboutForm = item2
                                    this.imgUrl = `https://img.shareplay.cc/${item2.value.logo}`
                                }
                            })
                        })
                    }
                })
                console.log(res)
            })
    
    
        },
        methods: {
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleDetailSuccess(res, file) {
                this.picArr.push({
                    imgUrl: `https://img.shareplay.cc/${res.key}`,
                    title: this.title
    
                })
            },
            handleAvatarSuccess(res, file) {
                this.imgUrl = `https://img.shareplay.cc/${res.key}`
                this.aboutForm.value.logo = res.key
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                this.uptoken = {
                    token: sessionStorage.token
                }
    
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleError() {
                this.$message.error('请重新登录')
                this.$router.push('/login')
            },
            beforeDetailUpload() {
    
            },
    
            onSubmit() {
                let about = JSON.parse(JSON.stringify(this.aboutForm))
                let ids = about.id
                console.log(ids)
                delete this.aboutForm.id
                patchVersionsId(sessionStorage.userId, ids, this.aboutForm).then(res => {
                    console.log(res.data)
                    if(res.data) {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                })
    
    
    
    
            },
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// About.vue?577e918a